import React from 'react';
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import getMarkerSrc from './icons/helper';
import { formatDuration } from '../helpers/utils';

const MyMarker = ({ event, color, text, active, onToggle }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        position={{ lat: event.lat, lng: event.lng }}
        onClick={onToggle}
        ref={markerRef}
      >
        <img src={getMarkerSrc('stop', color, text)} alt="" width={24} />
      </AdvancedMarker>
      {active && (
        <InfoWindow anchor={marker} onCloseClick={onToggle}>
          <div className="info-window">
            <div className="col-1">
              <h5>{event.time}</h5>
              <p>{formatDuration(event.duration)}</p>
              <p>
                {event.price === 0 ? (
                  <span className="price-free">Free</span>
                ) : (
                  <span className="price">
                    {event.currency} {event.price}
                  </span>
                )}
              </p>
            </div>
            <div className="col-2">
              <h3>{event.location}</h3>
              <p>{event.description}</p>
            </div>
          </div>
        </InfoWindow>
      )}
    </>
  );
};

export default MyMarker;
